import { notify } from 'utils/reduxUtils';

export const types = {
  DASHBOARD_LIST_INIT_ERROR: 'tasks/dashboard/DASHBOARD_LIST_INIT_ERROR',
  DASHBOARD_LIST_INIT_REQUEST: 'tasks/dashboard/DASHBOARD_LIST_INIT_REQUEST',
  DASHBOARD_LIST_INIT_SUCCESS: 'tasks/dashboard/DASHBOARD_LIST_INIT_SUCCESS',
};

export const dashboardListInit = {
  error: notify(
    (error) => ({
      type: types.DASHBOARD_LIST_INIT_ERROR,
      payload: error,
    }),
    'Error fetching tasks',
  ),
  request: () => ({
    type: types.DASHBOARD_LIST_INIT_REQUEST,
  }),
  success: ({ tasks }) => ({
    type: types.DASHBOARD_LIST_INIT_SUCCESS,
    payload: { tasks },
  }),
};
